<template>
  <button
    type="button"
    :class="['navbar-toggler', !expanded && 'collapsed']"
    :aria-controls="id"
    :aria-expanded="expanded ? 'true' : 'false'"
    aria-label="Toggle navigation"
    @click="toggle"
  >
    <span class="navbar-toggler-icon" />
  </button>

  <div :id="id" :class="['collapse navbar-collapse', expanded && 'expanded']">
    <ul class="navbar-nav ms-auto mt-4 mt-lg-0">
      <component
        :is="getNavItemComponent(item)"
        v-for="(item, index) in processedItems"
        :id="`nav-item-${index}`"
        :key="index"
        :class="['nav-item', item.border && 'nav-item-border']"
        :item="item"
        :index="index"
        v-bind="item.props"
      />
    </ul>
  </div>
</template>

<script setup>
import { replaceP12Placeholder } from '@shared/constants/p12'
import { defineAsyncComponent, ref, computed } from 'vue'

function getNavItemComponent (item) {
  const componentName = item.type === 'component'
    ? item.label
    : item.submenu?.length
      ? 'GuNavItemDropdown'
      : 'GuNavItemLink'

  // Vite needs a prefix for dynamically imported components
  // @see https://github.com/rollup/plugins/tree/master/packages/dynamic-import-vars#limitations
  return defineAsyncComponent(() => import(`./GuNavItem${componentName.substring(9)}.vue`))
}

const props = defineProps({
  items: {
    type: Array,
    default () {
      return []
    },
  },
  id: {
    type: String,
    default: 'main-navigation',
  },
})

const expanded = ref(false)

const toggle = () => {
  expanded.value = !expanded.value
}

const processedItems = computed(() => {
  const processItem = (item) => {
    const newItem = { ...item }
    if (newItem.submenu) {
      newItem.submenu = newItem.submenu.map(processItem)
    } else if (newItem.url) {
      newItem.url = replaceP12Placeholder(newItem.url)
    }
    return newItem
  }

  return props.items.map(processItem)
})


</script>
